import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14 2.8c6.175 0 11.2 5.025 11.2 11.2 0 6.175-5.025 11.2-11.2 11.2-6.175 0-11.2-5.025-11.2-11.2C2.8 7.825 7.825 2.8 14 2.8ZM14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14S21.732 0 14 0Zm7 12.6h-5.6V7h-2.8v5.6H7v2.8h5.6V21h2.8v-5.6H21v-2.8Z",
      fill: "#394053"
    }, null, -1)
  ]))]))
}
export default { render: render }